import { StringEditor } from "@serenity-is/corelib";

StringEditor.prototype['initialize'] = (function (old) {
    return function () {
        old.call(this);
        this.element.attr("autocomplete", "off");
    };
})(StringEditor.prototype['initialize']);